import React, { useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';

import { Container } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';

function CreateEditContent({ mountedData }) {
  const [ativo, setAtivo] = useState(!mountedData ? 'true' : mountedData?.ativo ? 'true' : 'false');

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
        };
        let response;
        if (mountedData?.id) response = await api.put('/signed/empresa/suporte/nivel', thisData);
        else response = await api.post('/signed/empresa/suporte/nivel', thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } essa Nivel, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } essa Nivel?`,
        successModal: `Nivel ${mountedData?.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        <div className="row">
          <Label title="Título *" className="col s6 m6 l6">
            <Input name="titulo" defaultValue={mountedData?.titulo} />
          </Label>
          <Label title="Valor Hora (R$)" className="col s3 m3 l3">
            <Input
              name="valorHora"
              type="number"
              step="0.01"
              min="0"
              defaultValue={mountedData?.valorHora}
              placeholder="0,00"
            />
          </Label>
          <Label title="Ativo *" className="col s2 m2 l2">
            <Select
              isString
              list={{
                list: [
                  { id: 'true', titulo: 'Sim' },
                  { id: 'false', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setAtivo(v);
              }}
            />
          </Label>
        </div>
        <div className="row">
          <Label title="Descrição" className="col s8 m8 l8">
            <TextArea name="descricao" defaultValue={mountedData?.descricao} />
          </Label>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
